import { constants } from '../../constants';
import { formatUtils, numericUtils } from '../../utils';

interface GuidanceRangeProps {
    guidanceMin?: number;
    guidanceMax?: number;
}

export function GuidanceRange({ guidanceMin, guidanceMax }: GuidanceRangeProps) {
    if (guidanceMin == null && guidanceMax == null) return <>{constants.emptyPlaceholder}</>;

    const min = guidanceMin ?? guidanceMax!;
    const max = guidanceMax ?? guidanceMin!;

    const roundedMin = numericUtils.round(Math.min(min, max), 0);
    const roundedMax = numericUtils.round(Math.max(min, max), 0);

    return (
        <span>
            {roundedMin === roundedMax ? formatUtils.formatDecimal(min, 1) : `${roundedMin} - ${roundedMax}`}
        </span>
    );
}
